// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3RvXK","alert":"SettungsInbox_alert__2ueOL"};